// 法语
export default {
  Login: {
    Title: "Connectez-vous à votre compte",
    describe: "Veuillez vous connecter ou créer un compte pour commencer.",
    Google: "Continuer avec Google",
    Apple: "Continuer avec Apple",
    or: "OU",
    Emailplaceholder: "Adresse e-mail",
    Passwordplaceholder: "Mot de passe",
    Login: "Se connecter",
    forgot: "Mot de passe oublié ?",
    notAccount: "Vous n'avez pas de compte Fineshare ?",
    Signup: "S'inscrire",
    InvalidEmail: "Format d'email invalide.",
    InvalidPassword: "Le mot de passe doit contenir au moins 6 caractères.",
    loading: "Chargement...",
    login: "Se connecter",
    errorText:"Échec de la connexion, veuillez vérifier votre nom d'utilisateur et votre mot de passe.",
  },
  signup: {
    Title: "Créez votre compte",
    describe: "Créez votre compte Fineshare en quelques secondes.",
    Google: "S'inscrire avec Google",
    Apple: "S'inscrire avec Apple",
    or: "OU",
    Emailplaceholder: "Entrez l'adresse e-mail",
    Passwordplaceholder: "Entrez un mot de passe de 6 caractères",
    Already: "Vous avez déjà un compte ?",
    Login: "Se connecter",
    By: "En créant un compte, j'accepte d'avoir lu et accepté la",
    Privacy: "Politique de confidentialité",
    Terms: "Conditions d'utilisation",
    and: "et",
    signupText: "Créer votre compte",
    InvalidEmail: "Format d'email invalide.",
    InvalidPassword: "Le mot de passe doit contenir au moins 6 caractères.",
    loading: "Chargement...",
    passwordError: "L'adresse e-mail est déjà enregistrée",
    again: "Vous faites trop de demandes, veuillez réessayer plus tard.",
    Registration:"Échec de l'inscription, veuillez vérifier votre e-mail et votre mot de passe.",
    hasRegistered: "L'adresse e-mail est déjà enregistrée",
  },
  Home: {
    Welcome: "Bienvenue dans le Centre de comptes Fineshare",
  },
};
